// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"407":"806878ea","616":"31d6cfe0","704":"78a6b640"}[chunkId] + ".chunk.css";
};